import { render, staticRenderFns } from "./TabSettingsModal.vue?vue&type=template&id=62db0224&scoped=true"
import script from "./TabSettingsModal.vue?vue&type=script&lang=js"
export * from "./TabSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TabSettingsModal.vue?vue&type=style&index=0&id=62db0224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db0224",
  null
  
)

export default component.exports